import { render, staticRenderFns } from "./AttachmentImageModalForm.vue?vue&type=template&id=228d2084&scoped=true&"
import script from "./AttachmentImageModalForm.vue?vue&type=script&lang=ts&"
export * from "./AttachmentImageModalForm.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentImageModalForm.vue?vue&type=style&index=0&id=228d2084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228d2084",
  null
  
)

export default component.exports